/**
 * Contient les fonctions algolia commune utilisé par les blocs tematik_recette et tematik_produits
 */
import { history } from 'instantsearch.js/es/lib/routers';

/**
 * 
 * tematik_produit & tematik_recette
 */

/**
 * Permet de garder le contenu des filtres algolia lors d'un changement de page
 * Retourne le router à passer en parametre à instantsearch: routing
 * @param {string} indexName, nom de l'index d'algolia
 * @return {object}
 */
export function getCustomRouter(indexName, initialUiState = {})
{
    let router = { 
        router: history({
            createURL({ qsModule, routeState, location }) {
                let baseUrl = location.origin + location.pathname;
                let queryParameters = {};

                if (routeState.query) {
                    queryParameters.query = encodeURIComponent(routeState.query);
                }

                if (routeState.page) {
                    queryParameters.page = encodeURIComponent(routeState.page);
                }
               
                // Permet de changer le titre des recettes
                if (routeState.produits_lies) {
                    changeTitle(routeState.produits_lies[0]);
                } else {
                    changeTitle();
                }

                for (const [key, value] of Object.entries(routeState)) {
                    if (key === "query" || key === "page"){
                        continue;
                    }
                    if (Array.isArray(value)) {
                        value = value.map(encodeURIComponent);
                    } else {
                        value = encodeURIComponent(value);
                    }
                    queryParameters[key] = value;
                }

                const queryString = qsModule.stringify(queryParameters, {
                    addQueryPrefix: true,
                    arrayFormat: 'repeat'
                });

                return `${baseUrl}${queryString}`;
            },
            parseURL({ qsModule, location }) {
                const parameters = qsModule.parse(
                  location.search.slice(1)
                );

                // Permet de changer le titre des recettes
                if (parameters.produits_lies) {
                    if (Array.isArray(parameters.produits_lies)) {
                        changeTitle(parameters.produits_lies[0]);
                    } else {
                        changeTitle(parameters.produits_lies);
                    }
                    
                } else {
                    changeTitle();
                }
                
                for (const [key, value] of Object.entries(parameters)) {
                    if (key === "query" || key === "page"){
                        parameters[key] = decodeURIComponent(parameters[key]);
                        continue;
                    }

                    parameters[key] = Array.isArray(value)
                    ? value.map(decodeURIComponent)
                    : [decodeURIComponent(value)].filter(Boolean);
                }

                return parameters;
              }
        }),

        stateMapping: {
            stateToRoute(uiState) {
                const indexUiState = uiState[indexName] || {};
                return {
                    query: indexUiState.query,
                    page: indexUiState.page,
                    ...indexUiState.refinementList
                };
            },
            routeToState(routeState) {
                if (Object.keys(routeState).length === 0) {
                    routeState = initialUiState[indexName];
                }
                const query = routeState.query;
                const page = routeState.page;
                delete routeState.query;
                delete routeState.page;
                return {
                    [indexName]: {
                        query,
                        page,
                        refinementList: {...routeState}
                    }
                };
            }
        }
    }
    return router
}


/**
 * Les identifiantsAPI
 * permet de recupérer les appID et apiID
 */
export function getApiIdentifiant()
{
    let algoliaAppId = $('.tematik_list_algolia').data('algolia-app-id');
    let algoliaApiId = $('.tematik_list_algolia').data('algolia-api-id');

    if (algoliaAppId.length === 0 || algoliaAppId.length === 0) return null;

    return {
        "appId": algoliaAppId,
        "apiId": algoliaApiId
    }
}

/**
 * Retourne les filtres sélectionnés dans les paramètres de bloc sous forme d'objet
 * @return {string} filtres
 */
export function getFiltres()
{
    let filtres = $('.tematik_list_algolia').data('filtres');
    return filtres;
}

/**
 * Retourne les filtres définis dans la barre de recherche du dashboard sous forme d'objet
 * @return {string} searchFiltres
 */
export function getSearchFiltres()
{
    let searchFiltres = $('.tematik_list_algolia').data('search-filtres');
    return searchFiltres;
}

/**
 * @return {string}
 */
export function getPageId()
{
    let pageId = $('.tematik_list_algolia').data('page-id');

    if (pageId === 0) return null;
    return pageId;
}

export function postRequestExist()
{
    return $('.tematik_list_algolia').data('post-request');
}


/**
 * Tematik recette
 */

/**
 * Récupère les ingrédients saisis et celui en cours de saisis (dans l'input)
 */
export function getAllIngredientValues()
{
    let tabElement = [];
    $('.wrapper span').each(function(e) {
        let value = $(this).text()
        tabElement.push(value);
    });

    return tabElement;
}

/**
 * Retourne la valeur du champs de recherche
 */
export function getSearchInputValue()
{
    return $('#inputBarreVisible').val();
}

// Permet de rendre le titre des recettes dynamiquement
function changeTitle(produitID = false)
{
    let title = getDefaultTitle();
    if (produitID) {
        title = getTitle();
        fetch(`/controller/markal/getProductNameById/${produitID}/${getLang()}`)
        .then((response) => response.json())
        .then((json) => {
            $('.titreSection h1').html(title + ' ' + json.nom);
        })
    } else {
        $('.titreSection h1').html(title);
    }
}

// Get titre avec produit
function getTitle()
{
    let title = $('.tematik_list_algolia').data('titre');
    return title;
}

function getDefaultTitle()
{
    let title = $('.tematik_list_algolia').data('titre-defaut');
    return title;
}

function getLang()
{
    let lang = $('.tematik_list_algolia').data('langue');
    return lang;
}